import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete';
import {TextField, LinearProgress} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {getProjects} from 'actions'
import {isUndefined, isNull} from 'lodash'
import IntlMessages from 'util/IntlMessages';
export default function SelectProjekt(props) {
  const dispatch = useDispatch()
  const ProjectList = useSelector(state => state.Projekt.ProjectList)
  const ProjectLoading = useSelector(state => state.Projekt.ProjectLoading)
  const Afid = useSelector(state => state.auth.authUser.user_Afid)
  const Userid = useSelector(state => state.auth.authUser.user_id)
  
  const handleAddProjekt = (p) => {
    console.log(p)
    let Meta = "Projekt"
    if(!isNull(p)) props.onChangeHandleMulti(Meta, {id: p.id, ProjectName: p.ProjectName})   
  }

  const searchProjekt = (e) => {
    console.log(e)
    if(e.keyCode === 13){
      e.preventDefault()
    dispatch(getProjects(Afid, Userid, 0, 500, e.target.value, e.target.value === "" ? 1 : 3))
    }
  }
  React.useEffect(() => {
    dispatch(getProjects(Afid, Userid, 0, 500, "", 1))
  },[])

  return (
    <div>
              <form>
              <div style={{ height: 'auto', paddingTop: '10px' }}>
              <Autocomplete
                id="combo-box-art"
                
                options={ ProjectList}
                getOptionLabel={(Projekt) => {                    
                    return isUndefined(Projekt.ProjectName)?"":Projekt.ProjectName
                } }    
                clearOnBlur={false}
                value={0}
    noOptionsText={
      ProjectLoading ?
        <>
          <div className="d-flex flex-column align-items-center mb-1"><IntlMessages id={"Search.Point"} /></div>
          <LinearProgress color="primary" />
        </> : 
        <>
        {/* <MenuItem onClick={() => handleAddGhostProduct(searchValue)}>{searchValue}</MenuItem> */}
        <p><IntlMessages id={"Search.Body"} /></p>
        </>
        }
    
        renderInput={(params) => 
          <TextField {...params} variant="outlined" size="small" fullWidth 
          label={<IntlMessages id="Input.Choose.project" />}
          id="table-product-search"
          onKeyDown={e => searchProjekt(e)}
          />
          
        }
        // disableClearable
        // freeSolo
        // style={{padding: '3px 0 2px'}}
        // filterOptions={(options, filter) => {
        //   if(filter.inputValue === "")
        //     return FilterOptions(options)
        //   else
        //     return FilterOptions(options.filter(o => String(o.Artname).toUpperCase().startsWith(String(filter.inputValue).toUpperCase())))
        // }}
        onChange={(e, p, r) => {
          handleAddProjekt(p)
        }}
        />
          </div>
        </form>
            </div>
  )
}
